// src/components/NRF.js
import React from 'react';

const NRF = () => {
  return (
    <div className="nrf-container">
      <h2>NIRF Ranking</h2>
      <p>
        The National Institutional Ranking Framework (NIRF) is a methodology adopted by the Ministry of Education, Government of India, to rank institutions of higher education in India.
      </p>
      <p>
        Sumatidevi Tompe Institute aims to benchmark its performance against national standards and continuously improve its ranking based on teaching, learning & resources, research and professional practice, graduation outcomes, outreach & inclusivity, and perception.
      </p>
     
    </div>
  );
};

export default NRF;